export default import.meta.ROLLDOWN_FILE_URL_3AbdWWgtbrvJIojXBl8n$Q